var s = Object.defineProperty;
var d = (r, t, e) => t in r ? s(r, t, { enumerable: !0, configurable: !0, writable: !0, value: e }) : r[t] = e;
var n = (r, t, e) => d(r, typeof t != "symbol" ? t + "" : t, e);
class u {
  constructor() {
    n(this, "ym", null);
    n(this, "config", { enabled: !1, ymId: null });
    n(this, "yaCounterInitialized", !1);
    n(this, "dispatchYmItem", (t) => {
      this.yaCounterInitialized && t();
    });
    n(this, "checkYaCounterInitialized", () => {
      document.addEventListener(`yacounter${this.getYandexMetricId()}inited`, this.checkYaCounter);
    });
    n(this, "checkYaCounter", () => {
      this.yaCounterInitialized = !0, document.removeEventListener(`yacounter${this.getYandexMetricId()}inited`, this.checkYaCounter);
    });
    this.initLogger();
  }
  init(t) {
    if (!(t != null && t.enabled) || !t.ymId) return;
    const { enabled: e, ymId: i, ...a } = t;
    this.config = { enabled: e && typeof t.ymId == "number", ymId: i, ...a }, this.initService();
  }
  hit(t, e) {
    !this.config.enabled || !t || this.dispatchYmItem(() => {
      var i;
      return (i = this.ym) == null ? void 0 : i.call(this, this.getYandexMetricId(), "hit", t, e);
    });
  }
  params(t) {
    this.config.enabled && t && this.dispatchYmItem(() => {
      var e;
      return (e = this.ym) == null ? void 0 : e.call(this, this.getYandexMetricId(), "params", t);
    });
  }
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  reachGoal(t, e, i, a) {
    if (!this.config.enabled) return;
    const c = this.setDynamicValues(t, e);
    c && this.dispatchYmItem(() => {
      var o;
      (o = this.ym) == null || o.call(this, this.getYandexMetricId(), "reachGoal", c, e, typeof i == "function" ? i : void 0, a);
    });
  }
  initService() {
    var t;
    typeof window.ym == "function" && this.config.enabled && (this.checkYaCounterInitialized(), this.ym = window.ym, (t = this.ym) == null || t.call(this, this.getYandexMetricId(), "init", {
      clickmap: this.config.clickmap ?? !0,
      trackLinks: this.config.trackLinks ?? !0,
      accurateTrackBounce: this.config.accurateTrackBounce ?? !0,
      webvisor: this.config.webvisor ?? !0,
      triggerEvent: this.config.triggerEvent ?? !0
    }));
  }
  initLogger() {
    window.ymHelperLib = () => {
      console.log("1. Чтобы проверить наличие счетчика на странице, введите ymCounterExistLib() в консоль"), console.log("2. Чтобы проверить инициализацию счетчика на странице, введите ymCounterInitializedLib() в консоль"), console.log("3. Чтобы увидеть отправленные ивенты, введите ymDataLib() в консоль");
    }, window.ymCounterExistLib = () => {
      const t = new URL(window.location.href);
      t.searchParams.append("_ym_status-check", `${this.getYandexMetricId()}&_ym_lang=ru`), window.location.href = t.toString();
    }, window.ymCounterInitializedLib = () => {
      this.yaCounterInitialized && console.log(`Счетчик ${this.getYandexMetricId()} можно использовать`);
    }, window.ymDataLib = () => {
      const t = new URL(window.location.href);
      t.searchParams.append("_ym_debug", "1"), window.location.href = t.toString();
    };
  }
  getYandexMetricId() {
    return this.config.ymId ?? 0;
  }
  setDynamicValues(t, e) {
    var a;
    if (!e || !((a = e.dynamic_values) != null && a.length)) return t;
    let i = 0;
    return t.toString().replace(/\{.*?\}/gm, () => {
      var o;
      const c = ((o = e.dynamic_values) == null ? void 0 : o[i]) ?? "";
      return i += 1, c.toString();
    });
  }
}
export {
  u as YandexMetrics
};
